import { render, staticRenderFns } from "./site-carousel.vue?vue&type=template&id=1cf1facb"
import script from "./site-carousel.vue?vue&type=script&lang=js"
export * from "./site-carousel.vue?vue&type=script&lang=js"
import style0 from "./site-carousel.vue?vue&type=style&index=0&id=1cf1facb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports